import { render, staticRenderFns } from "./PriceContract.vue?vue&type=template&id=69164c18&scoped=true"
import script from "./PriceContract.vue?vue&type=script&lang=js"
export * from "./PriceContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69164c18",
  null
  
)

export default component.exports